import { faSignIn } from "@fortawesome/pro-solid-svg-icons/faSignIn";
import { faEyeSlash } from "@fortawesome/pro-solid-svg-icons/faEyeSlash";
import { faEye } from "@fortawesome/pro-solid-svg-icons/faEye";
import { faCaretUp } from "@fortawesome/pro-solid-svg-icons/faCaretUp";
import { faCaretDown } from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import { faInbox } from "@fortawesome/pro-solid-svg-icons/faInbox";
import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons/faExclamationCircle";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import { faTimesCircle } from "@fortawesome/pro-solid-svg-icons/faTimesCircle";
import { faUserPlus } from "@fortawesome/pro-solid-svg-icons/faUserPlus";
import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faArrowRotateLeft } from "@fortawesome/pro-solid-svg-icons/faArrowRotateLeft";
import { faXmark } from "@fortawesome/pro-solid-svg-icons/faXmark";
import { faEnvelope } from "@fortawesome/pro-solid-svg-icons/faEnvelope";
import { faLockKeyhole } from "@fortawesome/pro-solid-svg-icons/faLockKeyhole";
import { faEllipsisH } from "@fortawesome/pro-solid-svg-icons/faEllipsisH";
import { faAngleDoubleRight } from "@fortawesome/pro-solid-svg-icons/faAngleDoubleRight";
import { faAngleDoubleLeft } from "@fortawesome/pro-solid-svg-icons/faAngleDoubleLeft";
import { faUser } from "@fortawesome/pro-solid-svg-icons/faUser";

export default [
	faSignIn, faEyeSlash, faEye, faCaretUp, faCaretDown, faInbox, faExclamationCircle, faCheckCircle,
	faTimesCircle, faUserPlus, faCheck, faArrowRotateLeft, faXmark, faEnvelope, faLockKeyhole, faEllipsisH,
	faAngleDoubleRight, faAngleDoubleLeft, faUser
];
